<div class="intel-dashboard">
    <div class="intel-header">
        <div>
            <p class="intel-title">Centro de inteligencia operativa</p>
            <p class="intel-subtitle">Control de gastos y rentabilidad operativa en tiempo real</p>
        </div>
        <div class="intel-filters">
            <app-date-range-picker
                [from]="filterFrom" [to]="filterTo"
                (fromChange)="filterFrom = $event" (toChange)="filterTo = $event"
                (rangeApplied)="onFilterChanged()">
            </app-date-range-picker>
            <select class="intel-select" [(ngModel)]="filterStatusId" (ngModelChange)="onFilterChanged()">
                <option value="">Todos los servicios</option>
                <option *ngFor="let s of statuses" [value]="s.id">{{s.name}}</option>
            </select>
        </div>
    </div>

    <ng-container *ngIf="data">
        <div class="intel-kpi-grid">
            <app-kpi-card
                icon="assets/img/icons/intel-kpi-dollar.svg" iconBg="#f3e8ff"
                label="Costo promedio por km"
                [value]="formatCurrency(data.kpis.cost_per_km.value)"
                [changePct]="data.kpis.cost_per_km.change_pct" changeTone="bad"
                [trend]="data.kpis.cost_per_km.trend" trendColor="#9810fa">
            </app-kpi-card>
            <app-kpi-card
                icon="assets/img/icons/intel-kpi-route.svg" iconBg="#dbeafe"
                label="Kilómetros recorridos"
                [value]="formatKm(data.kpis.km_total.value)"
                [changePct]="data.kpis.km_total.change_pct" changeTone="good"
                [trend]="data.kpis.km_total.trend" trendColor="#155dfc">
            </app-kpi-card>
            <app-kpi-card
                icon="assets/img/icons/intel-kpi-wallet.svg" iconBg="#ffe2e2"
                label="Gasto operativo total"
                [value]="formatCurrency(data.kpis.gasto_total.value)"
                [changePct]="data.kpis.gasto_total.change_pct" changeTone="bad"
                [trend]="data.kpis.gasto_total.trend" trendColor="#e7000b">
            </app-kpi-card>
            <app-kpi-card
                icon="assets/img/icons/intel-kpi-warning.svg" iconBg="#ffedd4"
                label="Servicios con pérdida"
                [value]="data.kpis.services_with_loss.value"
                [subLabel]="'de ' + data.kpis.services_with_loss.total_services + ' servicios'"
                [changePct]="data.kpis.services_with_loss.change_pct" changeTone="warn"
                [trend]="data.kpis.services_with_loss.trend" trendColor="#f54900">
            </app-kpi-card>
        </div>

        <!-- Fila 2: columna de tarjetas secundarias (operador de mayor gasto
             arriba, viáticos/unidad más costosa abajo) + Ranking por unidad,
             ambas mitades al 50% — así lo pide el diseño, no 3 columnas
             iguales. -->
        <div class="intel-row-2">
            <div class="intel-secondary-column">
                <div class="intel-secondary-card intel-secondary-card--wide">
                    <div class="intel-secondary-icon" style="background:#dbeafe">
                        <img src="assets/img/icons/intel-secondary-person.svg" alt="">
                    </div>
                    <div>
                        <p class="intel-secondary-label">Operador de mayor gasto</p>
                        <p class="intel-secondary-value">{{data.top_expense_driver?.name || '—'}}</p>
                        <p class="intel-secondary-sub" style="color:#e7000b">{{formatCurrency(data.top_expense_driver?.gasto_total)}}</p>
                    </div>
                </div>
                <div class="intel-secondary-pair">
                    <div class="intel-secondary-card">
                        <div class="intel-secondary-icon" style="background:#dcfce7">
                            <img src="assets/img/icons/intel-secondary-card.svg" alt="">
                        </div>
                        <div>
                            <p class="intel-secondary-label">Viáticos pendientes</p>
                            <p class="intel-secondary-value">{{formatCurrency(data.viaticos_pendientes?.amount)}}</p>
                            <p class="intel-secondary-sub intel-secondary-sub--count" style="color:#e7000b">{{data.viaticos_pendientes?.services_count || 0}} servicios</p>
                        </div>
                    </div>
                    <div class="intel-secondary-card">
                        <div class="intel-secondary-icon" style="background:#eaeaea">
                            <img src="assets/img/icons/intel-secondary-truck.svg" alt="">
                        </div>
                        <div>
                            <p class="intel-secondary-label">Unidad más costosa</p>
                            <p class="intel-secondary-value">{{data.top_cost_per_km_unit?.name || '—'}}</p>
                            <p class="intel-secondary-sub" style="color:#e7000b">{{formatCurrency(data.top_cost_per_km_unit?.cost_per_km)}} por km</p>
                        </div>
                    </div>
                </div>
            </div>
            <app-ranking-mini-panel groupBy="unit"></app-ranking-mini-panel>
        </div>

        <!-- Fila 3: Ranking por cliente + Ranking por operador, 50/50. -->
        <div class="intel-row-3">
            <app-ranking-mini-panel groupBy="client"></app-ranking-mini-panel>
            <app-ranking-mini-panel groupBy="driver"></app-ranking-mini-panel>
        </div>
    </ng-container>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
